/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function CurrencyBtc(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M170.4834,115.70117A43.973,43.973,0,0,0,144,40.18994V24a8,8,0,0,0-16,0V39.999l-16-.00146V24a8,8,0,0,0-16,0V39.99658l-16.00488-.00146h-16.001a8,8,0,0,0,0,16h8v136h-8a8,8,0,0,0,0,16h15.999L96,207.99609V224a8,8,0,0,0,16,0V207.99707l16,.00147V224a8,8,0,0,0,16,0V207.99951L152,208a48.00015,48.00015,0,0,0,18.4834-92.29883ZM168,84a28.03146,28.03146,0,0,1-28,28H87.99414V55.99609l15.95215.001c.01807.00049.03564.00293.05371.00293s.03564-.00244.05371-.00293l31.94043.00244L136,56l.00586-.00049L140,56A28.03146,28.03146,0,0,1,168,84ZM152.001,192l-64.00684-.00391V128H152a32,32,0,0,1,.001,64Z" />
    </Svg>
  );
}

export default CurrencyBtc;
